// 將文字轉為半形
export const toHalfWidth = (input: string): string => {
  return input
    .replace(/[\uFF01-\uFF5E]/g, (char) => {
      return String.fromCharCode(char.charCodeAt(0) - 0xfee0);
    })
    .replace(/\u3000/g, ' ');
};
